import { ROLE_TYPE } from '@user/role-type';
import { NavItem } from '../nav-item.model';
import { MainMenuCategory } from '@main-navigation/shared/main-menu-category.enum';

export class FinanceAnalyticsNav {
  public static item: NavItem = {
    title: 'main-navigation.analytics',
    icon: '<img src="./assets/icons/line-icons/nav/colors/pie-chart-03.svg" width="24px" height="24px">',
    themedIcon: {
      avorenewables: '<img src="./assets/images/avorenewables/icons/pie-chart-03.svg" width="24px" height="24px">'
    },
    bold: true,
    type: MainMenuCategory.analytics,
    roles: [ROLE_TYPE.DATA_ANALYST],
    children: [
      {
        title: 'main-navigation.dashboard',
        url: '/oes/analytics/dashboards',
        testId: 'analytics-nav-link',
        roles: [ROLE_TYPE.DATA_ANALYST],
      },
      {
        title: 'main-navigation.data-integrations',
        url: '/oes/analytics/data-integrations',
        testId: 'data-integrations-nav-link',
        roles: [ROLE_TYPE.ORGANIZATION_ADMIN],
      }
    ]
  };
}
